import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings";
import {NavigationSectionType} from "../../../model2/navigation/@const";

const fieldsConfig = {

    // 'viewsSettings': {
    //     type            : 'value',
    //     defaultValue    : {},
    // },

    'displayIn': {
        type            : ServerSettingsFieldType.OPTION,
        options         : [NavigationSectionType.HOME, NavigationSectionType.MORE, NavigationSectionType.NAVIGATION_PANEL],
        defaultValue    : NavigationSectionType.HOME
    }
}

const debug = false
// const debug = "UserSettingsViewsMyWork"

export default class UserSettingsViewsNotifications extends ServerSettings {

    // public viewsSettings    : any
    public displayIn        : NavigationSectionType

    constructor(config: any) {

        super(config, fieldsConfig);

        // default current view
        // this.viewsSettings  = this.initValue('viewsSettings')
        this.displayIn      = this.initValue('displayIn')
    }


    toJson() {
        const result = {};

        // this.valueToJson(result, 'viewsSettings')
        this.valueToJson(result, 'displayIn')

        debug && console.log(debug, 'toJson', result, this)

        return result;
    }
}
